import React from 'react';

const AuthLinks = ({}) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <a 
        className='dcgreen' 
        style={{ color: '#21ba45' }} 
        href="/users/sign_in/" 
        target="_blank" 
        rel="noopener noreferrer"
      >
        {l.sign_in}
      </a>
      <span style={{ color: '#ffffff' }}>{l.or}</span>
      <a 
        className='dcorange' 
        style={{ color: '#f2711c' }} 
        href="/users/sign_up" 
        target="_blank" 
        rel="noopener noreferrer"
      >
        {l.create_an_account}
      </a>
    </div>
  );
};

export default AuthLinks;
